"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileExtension = void 0;
const getFileExtension = filename => {
  if (!filename || filename.indexOf(".") === -1) {
    return "";
  }
  const extension = filename.split(".").pop();
  if (!extension) {
    return "";
  }
  return extension.toLowerCase();
};
exports.getFileExtension = getFileExtension;
//# sourceMappingURL=getFileExtension.js.map